// extracted by mini-css-extract-plugin
export default {"root":"PlasmicInfo_root__mHIi8","svg":"PlasmicInfo_svg__ua2xe","svgdisabled":"PlasmicInfo_svgdisabled__tzadw"};